module.exports = __webpack_public_path__ + "media/icons/opony-felgi-menu-5de04630.png";